<table class="mat-table">
  <tr class="mat-header-row">
    <th class="mat-header-cell">Documento</th>
    <th class="mat-header-cell">Avaliado/Situação</th>
    <th class="mat-header-cell"></th>
  </tr>
  <tr class="mat-row" *ngIf="data.planoAtividades">
    <td class="mat-cell">Plano de atividades</td>
    <td class="mat-cell">{{ data.analisePlanoAtividades }}</td>
    <td class="mat-cell" class="text-right">
      <a mat-stroked-button (click)="download('plano_atividade', 'Plano de atividades', data.idInscricao)"
        ><mat-icon>file_download</mat-icon> Visualizar</a
      >
    </td>
  </tr>
  <tr class="mat-row" *ngIf="data.relatorioAtividades">
    <td class="mat-cell">Relatório de atividades</td>
    <td class="mat-cell">{{ data.analiseRelatorioAtividades }}</td>
    <td class="mat-cell" class="text-right">
      <a mat-stroked-button (click)="download('relatorio', 'Relatório de atividades', data.idInscricao)"
        ><mat-icon>file_download</mat-icon> Visualizar</a
      >
    </td>
  </tr>
</table>
